import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button, Header, Grid, Segment, Loader, Icon, Table, Label, Checkbox } from 'semantic-ui-react'
import { SubeditorArea } from '~/common/subeditor'

export default class ContentInfo extends PureComponent {
  state = {
    editing: false,
  }

  render() {
    let { editing } = this.state
    let { interview = Map(), updateInterview } = this.props
    let contentInfo = interview.getIn(['data', 'contentInfo'], '')

    let buttons = (
      <div>
        <button
          className="button-plain"
          onClick={e => {
            e.preventDefault()
            if (editing)
              updateInterview({ data: interview.get('data', Map()).set('contentInfo', this._textarea.value).toJS() })

            this.setState({ editing: editing === false }, () => (this._textarea ? this._textarea.focus() : false))
          }}>
          {editing ? 'Tallenna' : 'Muokkaa'}
        </button>
      </div>
    )

    return (
      <SubeditorArea title="Sisältötoiveet" buttons={buttons}>
        {editing ? (
          <textarea defaultValue={contentInfo} ref={el => (this._textarea = el)} />
        ) : (
          <div className="order-editor-field-text">{contentInfo || 'Lisää sisältötoive'}</div>
        )}
      </SubeditorArea>
    )
  }
}
